import QuestionStats from 'Shared/Surveys/components/QuestionStats'
import ActionHeader from './ActionHeader'
import useActionLabel from '../../useActionLabel'
import './ActionStats.scoped.scss'

export default function Survey({ flowId, actionId, removed }) {
  const label = useActionLabel('survey')

  return (
    <div className="flow-action-stats">
      <div className='box margin-top double' id='survey'>
        <ActionHeader flowId={flowId} actionId={actionId} title={`${label}${removed ? ' (removed)' : ''}`} />
        <QuestionStats className="" />
      </div>
    </div>
  )
}
